export function* trackUserSignup({ user }) {
  yield;
  try {
    // eslint-disable-next-line no-undef
  } catch {
    /* do nothing */
  }
}
